<template>
  <div>
    <!-- pc端 -->
    <header class="header">
      <div class="w1200 clearfix">
        <div class="header_left">
          <router-link to="/home">主页</router-link>
          <router-link to="/team">关于</router-link>
          <router-link to="/project">项目</router-link>
          <router-link to="/customer">客户</router-link>
        </div>
        <div class="header_right">
          <router-link to="/certification">资质</router-link>
          <router-link to="/news">最新消息</router-link>
          <router-link to="/contact">联络我们</router-link>
        </div>
      </div>
    </header>

    <!-- 移动端 -->
    <header class="header_mobile">
      <i class="iconfont icon-caidan" @click="drawerShow = !drawerShow"></i>

      <Drawer placement="left" :closable="false" v-model="drawerShow">
        <router-link to="/home">主页</router-link>
        <router-link to="/team">关于</router-link>
        <router-link to="/project">项目</router-link>
        <router-link to="/customer">客户</router-link>
        <router-link to="/certification">资质</router-link>
        <router-link to="/news">最新消息</router-link>
        <router-link to="/contact">联络我们</router-link>
      </Drawer>

      <img
        src="~@/assets/images/logo.png"
        alt="深圳市同为装饰设计工程有限公司"
      />
    </header>
  </div>
</template>

<script>
import Vue from "vue";
import { Drawer } from "iview";
Vue.component("Drawer", Drawer);

export default {
  data() {
    return {
      drawerShow: false,
    };
  },
  created() {
    // alert(document.documentElement.clientWidth);
  },
  mounted() {
    // 百度统计
    this.statistics();
  },
  methods: {
    // 百度统计脚本
    statistics() {
      var _hmt = _hmt || [];
      (function() {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?a08843a30e6216171e70a86e14567c84";
        var s = document.getElementsByTagName("script")[0]; 
        s.parentNode.insertBefore(hm, s);
      })();
    }
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/components/header.scss";
</style>
